export default __webpack_public_path__ + "static/media/success-contact.a6140d30.svg";